export default function About() {
  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/fea1a1a51237cd5b41d6d3275d2c0f20/a6ca60c7bf6284540cf57d58ecb2bb86.png"
                alt="Chef Ziad Hafez - Private Chef London"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 sm:-bottom-8 sm:-right-8 w-32 h-32 sm:w-64 sm:h-64 bg-[#C9A961]/10 rounded-2xl -z-10"></div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-8 sm:w-12 h-0.5 bg-[#C9A961]"></div>
              <p className="text-[#C9A961] text-xs sm:text-sm tracking-[0.2em] uppercase font-light">
                About Chef Ziad
              </p>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold leading-tight mb-4 sm:mb-6">
              Culinary Excellence
              <br />
              <span className="text-[#C9A961] italic">Since 1993</span>
            </h2>

            <div className="space-y-3 sm:space-y-4 text-gray-600 text-sm sm:text-base font-light leading-relaxed mb-6 sm:mb-8">
              <p>
                <strong className="text-gray-900 font-semibold">Chef Ziad Hafez</strong> is a talented and experienced private chef with over 30 years of culinary expertise, specializing in Mediterranean cuisine and Kosher food preparation. Based in London, Chef Ziad brings exceptional skill in preparing professional meals for a variety of tastes and dietary requirements.
              </p>
              <p>
                His distinguished career includes serving as <strong className="text-gray-900 font-semibold">Executive Chef at Golden Sands Hotel Dubai</strong>, managing three kitchens (Oriental, Indian, and Continental), and owning <strong className="text-gray-900 font-semibold">Kamils Lebanese Restaurant in London</strong> for nearly a decade. Chef Ziad has also worked as <strong className="text-gray-900 font-semibold">Chef de Partie at prestigious venues</strong> including Crockers Folly (Maroush Restaurant) and Kings College.
              </p>
              <p>
                Currently serving as a dedicated private chef, Chef Ziad excels in creating bespoke dining experiences for families, special occasions, and private parties. His expertise spans fine dining, event catering, and specialized dietary menus, all prepared with fresh ingredients and meticulous attention to detail.
              </p>
              <p>
                With qualifications including an <strong className="text-gray-900 font-semibold">International Advanced Diploma in Food Preparation and Cookery Supervision (Level 3)</strong> from the Hospitality and Tourism College in Damascus, Chef Ziad maintains the highest standards in food safety, allergen awareness, and customer service.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
              <div className="text-center p-4 sm:p-6 bg-gray-50 rounded-xl">
                <div className="text-3xl sm:text-4xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">30+</div>
                <div className="text-xs sm:text-sm text-gray-600 font-light">Years Experience</div>
              </div>
              <div className="text-center p-4 sm:p-6 bg-gray-50 rounded-xl">
                <div className="text-3xl sm:text-4xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">1000+</div>
                <div className="text-xs sm:text-sm text-gray-600 font-light">Events Catered</div>
              </div>
            </div>

            <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A961] text-lg sm:text-xl"></i>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm font-light">Mediterranean & Middle Eastern Cuisine Specialist</span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A961] text-lg sm:text-xl"></i>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm font-light">Kosher Food Preparation Expert</span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A961] text-lg sm:text-xl"></i>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm font-light">Special Dietary Requirements & Allergen Management</span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A961] text-lg sm:text-xl"></i>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm font-light">Fine Dining & Event Catering</span>
              </div>
            </div>

            <a
              href="#contact"
              className="inline-block w-full sm:w-auto text-center px-6 sm:px-8 py-3 sm:py-4 bg-[#C9A961] text-white rounded-lg text-sm sm:text-base font-medium tracking-wide transition-all hover:bg-[#B89851] hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Book Chef Ziad
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
